module.exports = __webpack_public_path__ + "img/88.8.TSS.f4ebc885.png";